import PropTypes from "prop-types";

const propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string
};

export default propTypes;
